import Swiper, { Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const swipers = function (next) {
	const swiperElements = next.querySelectorAll(".swiper");

	if (swiperElements.length < 1) return; // didn't find any, exiting...

	let swiperInstances = [];

	swiperElements.forEach((el, index) => {
		let swiperIndex = el.dataset.swiperIndex || '';
		let slidesInView = el.dataset.slides || 1;
		let slideSpeed = el.dataset.speed || 1000;
		let slideLoop = el.dataset.loop || true;
		let showOverflow = el.dataset.showOverflow || false;
		let autoHeight = el.dataset.autoHeight || false;
		let options = {
			slidesPerView: parseInt(slidesInView),
			modules: [Navigation, Pagination],
			loop: slideLoop,
			loopedSlides: 4,
			autoHeight: autoHeight,
			speed: parseInt(slideSpeed),
			spaceBetween: 30,
			navigation: {
				nextEl: ".swnav-next-" + swiperIndex,
				prevEl: ".swnav-prev-" + swiperIndex,
			},
			pagination: {
				el: ".swpag-" + swiperIndex,
				type: "bullets",
				clickable: true,
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
					spaceBetween: 30,
				},
				// 400: {
				// 	slidesPerView: 2,
				// 	spaceBetween: 20,
				// },
				640: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
				// 768: {
				// 	slidesPerView: 3,
				// 	spaceBetween: 20,
				// },
				1024: {
					slidesPerView: parseInt(slidesInView),
					spaceBetween: 30,
				},
				// 1200: {
				// 	slidesPerView: 4,
				// 	spaceBetween: 30,
				// },
				// 1535: {
				// 	slidesPerView: 4,
				// 	spaceBetween: 30,
				// },
			},
		};
		swiperInstances.push(new Swiper(el, options));
	});

	return swiperInstances;
};

export default swipers;
